import {
  ITableColumn,
  ITableDataItem,
  formatDate,
} from "@inceptionbg/ui-components";
import { FC, useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FarmContext } from "../../AppContent";
import { Table } from "../../Components/CustomIUI/Table/Table";
import { getConsentRequests } from "../../repos/ConsentRepo";
import { Loader } from "../../Elements/Loader";

export const ConsentRequestsPage: FC = () => {
  const [data, setData] = useState<ITableDataItem[]>([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();
  const farmUuid = useContext(FarmContext).farm?.uuid;

  const columns: ITableColumn[] = [
    { id: "ownerName", label: t("ConsentOwnerName") },
    { id: "purpose", label: t("Purpose") },
    { id: "createdAt", label: t("ConsentRequestSendDate") },
    { id: "status", label: t("Status") },
  ];

  const handleGetConsentRequests = useCallback(() => {
    if (farmUuid) {
      setIsLoading(true);
      getConsentRequests(farmUuid, { limit, offset }, ["CLIENT"])
        .then(({ requests, totalRows }) => {
          setData(
            requests.map((request) => ({
              uuid: request.uuid,
              cells: {
                ownerName: { value: request.consentClient.ownerName },
                purpose: { value: request.consentClient.purpose },
                createdAt: { value: formatDate(request.createdAt) },
                status: {
                  value: request.status
                    ? t(`ConsentStatus${request.status}`)
                    : t(`ConsentStatusSENT`),
                },
              },
            })) as ITableDataItem[]
          );
          setTotalRows(totalRows);
        })
        .catch(() => {})
        .finally(() => setIsLoading(false));
    }
  }, [farmUuid, limit, offset, t]);

  useEffect(handleGetConsentRequests, [handleGetConsentRequests]);

  return (
    <Loader isLoading={isLoading}>
      <Table
        columns={columns}
        data={data}
        serverSidePagination={{
          limit,
          offset,
          setLimit,
          setOffset,
          totalRows,
        }}
        footerAction={{
          onClick: handleGetConsentRequests,
        }}
      />
    </Loader>
  );
};
